import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "e0837QamapP8J0B3tjIMQnG", "GuideMgr", undefined);

export var E_GuideStep;

(function (E_GuideStep) {
  E_GuideStep[E_GuideStep["None"] = 0] = "None";
  E_GuideStep[E_GuideStep["Tip_Wheel"] = 1] = "Tip_Wheel";
  E_GuideStep[E_GuideStep["Rotate_Wheel"] = 2] = "Rotate_Wheel";
  E_GuideStep[E_GuideStep["Tip_Energy"] = 3] = "Tip_Energy";
  E_GuideStep[E_GuideStep["Eat_Energy"] = 4] = "Eat_Energy";
  E_GuideStep[E_GuideStep["Tip_EnergyBtn"] = 5] = "Tip_EnergyBtn";
  E_GuideStep[E_GuideStep["Act_Energy"] = 6] = "Act_Energy";
  E_GuideStep[E_GuideStep["Tip_Kill"] = 7] = "Tip_Kill";
  E_GuideStep[E_GuideStep["End"] = 8] = "End";
})(E_GuideStep || (E_GuideStep = {}));

export var GuideMgr = /*#__PURE__*/function () {
  function GuideMgr() {}

  _createClass(GuideMgr, null, [{
    key: "I",
    get: function get() {
      if (!GuideMgr._I) {
        GuideMgr._I = new GuideMgr();
      }

      return GuideMgr._I;
    }
  }]);

  return GuideMgr;
}();

_defineProperty(GuideMgr, "_I", null);

_cclegacy._RF.pop();